import { useTranslation } from "react-i18next";

const Caching = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className="font-semibold text-[32px] text-center pb-10 ">
            {t("caching")}
          </h1>
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("howCachingApplies")}
          </h2>
          <section className="space-y-4">
            <div>
              <h3>{t("landFreight")}</h3>
              <p>
                <span className="text-mainRed">{t("problem")}</span>
                {t("ifThereUpdatesOrChanges")}
              </p>
              <p>
                <span className="text-mainBlue">{t("solution")}</span>
                {t("clearingYourBrowser")}
              </p>
            </div>
            <div>
              <h3>{t("seaFreight")}</h3>
              <p>
                <span className="text-mainRed">{t("problem")}</span>
                {t("youMayEncounter")}
              </p>
              <p>
                <span className="text-mainBlue">{t("solution")}</span>
                {t("clearingYourCache")}
              </p>
            </div>
            <div>
              <h3>{t("airFreight-")}</h3>
              <p>
                <span className="text-mainRed">{t("problem")}</span>
                {t("havingTroubleAccessing")}
              </p>
              <p>
                <span className="text-mainBlue">{t("solution")}</span>
                {t("clearingCacheHelpsEliminate")}
              </p>
            </div>
            <div>
              <h3>{t("customsServices")}</h3>
              <p>
                <span className="text-mainRed">{t("problem")}</span>
                {t("ifUpdatesCustomDuties")}
              </p>
              <p>
                <span className="text-mainBlue">{t("solution")}</span>
                {t("clearingCacheEnsureUpdates")}
              </p>
            </div>
          </section>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/caching1.jpg"
            alt="caching 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/caching2.jpg"
            alt="caching 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/caching1.jpg"
            alt="caching 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/caching2.jpg"
            alt="caching 4"
          />
        </section>
        {/* Partial Shipping */}
        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("whyClearingCacheIsImportant")}{" "}
          </h2>
          <h3>{t("getTheLatestInformation")}</h3>
          <p>
            <span className="text-mainBlue">{t("solveTechnicalIssues")}</span>
            {t("havingTroublePagesLoading")}
          </p>
          <p>
            <span className="text-mainBlue">{t("improvePerformance")}</span>
            {t("clearingCacheCanHelpImprovePerformance")}
          </p>

          {/* What is Partial Shipping*/}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("temporaryStorage")}
          </h3>
          <h4>{t("tempStorageService")}</h4>
          <div className="my-4">
            <h4 className="text-mainBlue"> {t("1temporaryStorage")}</h4>
            <p>{t("goodsAreStoredInMegtlogistics")}</p>
          </div>
          <div className="my-4">
            <h4 className="text-mainBlue">{t("2storageDuration")}</h4>
            <p>{t("tempStoragePeriod")}</p>
          </div>
          <div className="my-4">
            <h4 className="text-mainBlue">{t("3keyFunctions")}</h4>
            <p>{t("receivingGoods")}</p>
            <p>{t("storageItems")}</p>
            <p>{t("distributionOnDemand")}</p>
          </div>
          <div className="my-4">
            <h4 className="text-mainBlue">{t("4CostConsiderations")}</h4>
            <p>{t("costOfTemporaryStorage")}</p>
          </div>
          <div className="my-4">
            <h4 className="text-mainBlue">{t("5benefitsOfService")}</h4>
            <p>{t("flexibilityCustomers")}</p>
            <p>{t("securityEnsures")}</p>
            <p>{t("costSaving")}</p>
          </div>
          <div className="my-4">
            <h4 className="text-mainBlue">{t("6receivingAndDelivery")}</h4>
            <p>{t("afterStoragePeriod")}</p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Caching;
